import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/Layout.js";
import Image from '../components/Image';
import { Tabs, TabList, Tab, TabPanels, TabPanel } from '@reach/tabs';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Bueno, empecemos a pensar y hacer nuestro blog, `}<strong parentName="p">{`qué emoción`}</strong>{` 😱🎉`}</p>
    <p>{`Para nuestro blog vamos a escribir los posts en archivos MD
(`}<a parentName="p" {...{
        "href": "https://github.com/adam-p/markdown-here/wiki/Markdown-Cheatsheet"
      }}>{`Markdown`}</a>{`),
porque es un formato bastante amigable y se puede traducir a HTML de forma
fácil. De más está decir que para `}<strong parentName="p">{`transformar`}</strong>{` archivos MD a HTML tenemos un
plugin, no? 😎 Así que empecemos por ahí, vamos a generar archivos `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.md`}</code>{`, crear
la fuente de datos usando un plugin `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`source`}</code>{` (el mismo que se usa ahora para las
imágenes 😉) para que luego con el plugin de tipo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`transformer`}</code>{` podamos acceder
al contenido del archivo y nos convierta la data en algo amigable (HTML)
mientras estamos consultando en el frontend usando `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`GraphQL`}</code>{` 😊`}</p>
    <p>{`Si algo no se entendió, recomiendo releer estos últimos renglones, y hasta
podrían intentar hacerlo solos si se sienten confiados. Igual, si siguen
leyendo, lo hacemos! 💪 Empecemos por
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/plugins/?=markdown"
      }}>{`buscar un plugin`}</a>{` para manipular
los archivos Markdown y lo instalamos, encontramos este plugin
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/packages/gatsby-transformer-remark/?=markdown"
      }}>{`gatsby-transformer-remark`}</a>{`,
frenemos el servidor local y lo instalamos así:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "bash"
    }}><pre parentName="div" {...{
        "className": "language-bash"
      }}><code parentName="pre" {...{
          "className": "language-bash"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`npm`}</span>{` i gatsby-transformer-remark`}</code></pre></div>
    <p>{`Mientras se instala, preparemos nuestro plugin `}<strong parentName="p">{`plugin-source-filesystem`}</strong>{` para
levantar nuestros posts de una carpeta local y que sean consultables. Creemos
una carpeta dentro de `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/src`}</code>{`, a la misma altura que `}<strong parentName="p">{`components`}</strong>{`, `}<strong parentName="p">{`pages`}</strong>{`,
etc. y llamémosla `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`posts`}</code>{` por ejemplo. Ahora configuremos nuestro plugin igual a
como está para las imágenes, pero para posts y ya que estamos, podemos agregar
`}<strong parentName="p">{`gatsby-transformer-remark`}</strong>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`//En gatsby-config.js`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  resolve`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-source-filesystem`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  options`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    name`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`posts`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    path`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token interpolation"
            }}><span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`\${`}</span>{`__dirname`}<span parentName="span" {...{
                "className": "token interpolation-punctuation punctuation"
              }}>{`}`}</span></span><span parentName="span" {...{
              "className": "token string"
            }}>{`/src/posts`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
`}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-transformer-remark`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span></code></pre></div>
    <p>{`Genial! Con esto ya tenemos configurados los plugins, el de tipo `}<strong parentName="p">{`source`}</strong>{` nos
permite ver qué archivos están en esa carpeta `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`posts`}</code>{` y automáticamente el de
tipo `}<strong parentName="p">{`transformer`}</strong>{` se va a encargar de agarrar los archivos `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.md`}</code>{` y nos va a
dejar manipularlos y acceder a su contenido, `}<em parentName="p">{`transformándolo`}</em>{` en HTML para
manipularlo en el frontend 😁`}</p>
    <p>{`Les propongo algo, armemos un primer post y después la página donde va a estar
el listado de nuestros posts (de cómo mostrar cada post nos encargamos después
😉), así que empecemos por crear en `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/posts`}</code>{` un archivo nuevo con alguna fecha
anterior a hoy y un nombre, por ejemplo `}<strong parentName="p">{`primer-post.md`}</strong>{` y llenémoslo con
texto, a mi me gusta mucho `}<a parentName="p" {...{
        "href": "https://jeffsum.com/"
      }}>{`este lorem ipsum`}</a>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "markdown"
    }}><pre parentName="div" {...{
        "className": "language-markdown"
      }}><code parentName="pre" {...{
          "className": "language-markdown"
        }}><span parentName="code" {...{
            "className": "token front-matter-block"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`---`}</span>{`
`}<span parentName="span" {...{
              "className": "token font-matter yaml language-yaml"
            }}>{`title: 'Mi primer post'
date: '2019-10-20'`}</span>{`
`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`---`}</span></span>{`

`}<span parentName="code" {...{
            "className": "token title important"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`#`}</span>{` Mi primer post!`}</span>{`

`}<span parentName="code" {...{
            "className": "token italic"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`_`}</span><span parentName="span" {...{
              "className": "token content"
            }}>{`Este`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`_`}</span></span>{` es un post `}<span parentName="code" {...{
            "className": "token bold"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`**`}</span><span parentName="span" {...{
              "className": "token content"
            }}>{`BUENISIMO`}</span><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`**`}</span></span>{` y lleno de texto de
`}<span parentName="code" {...{
            "className": "token url"
          }}>{`[`}<span parentName="span" {...{
              "className": "token content"
            }}>{`este lorem ipsum`}</span>{`](`}<span parentName="span" {...{
              "className": "token url"
            }}>{`https://jeffsum.com/`}</span>{`)`}</span>{`.

God help us, we're in the hands of engineers. Eventually, you do plan to have
dinosaurs on your dinosaur tour, right? Must go faster. Remind me to thank John
for a lovely weekend. You really think you can fly that thing? Remind me to
thank John for a lovely weekend.

Life finds a way. Life finds a way. You know what? It is beets. I've crashed
into a beet truck. Must go faster... go, go, go, go, go! Checkmate... This thing
comes fully loaded. AM/FM radio, reclining bucket seats, and... power windows.
Eventually, you do plan to have dinosaurs on your dinosaur tour, right?`}</code></pre></div>
    <p>{`Todo muy lindo pero, qué son esos cosos `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`---`}</code>{` ahí arriba? Eso se llama
`}<strong parentName="p">{`frontmatter`}</strong>{` y todo lo que esté ahí adentro nos sirve como una especie de
`}<em parentName="p">{`metadata`}</em>{` de cada post. En un ratito lo usamos y creo que se va a entender un
poco más. Por ahora volvamos a levantar nuestro servidor local de desarrollo
(`}<strong parentName="p">{`gatsby develop`}</strong>{`) y vamos a ver si podemos consultar en `}<em parentName="p">{`GraphiQL`}</em>{` el post
que acabamos de hacer 😁`}</p>
    <p>{`Si prestamos atención, vemos que se agregaron dos campos nuevos para consultar
nuestro markdown, `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`allMarkdownRemark`}</code>{` y `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`markdownRemark`}</code>{`. Como viene siendo, el
que tiene `}<strong parentName="p">{`all`}</strong>{` es para traer `}<em parentName="p">{`todos`}</em>{` y el otro es para filtrar uno solo.
Nosotros queremos listar todos! Así que listemos toda la data que podamos que
nos parezca útil:`}</p>
    <Image imgName="mdgraphiql.png" alt="Markdown in GraphiQL" mdxType="Image" />
    <p>{`Recuerdan que `}<em parentName="p">{`edges`}</em>{` representaba la colección y `}<em parentName="p">{`node`}</em>{` cada uno de los objetos
de la colección, no? Es bueno refrescarlo por las dudas 😊 Además, el plugin nos
facilita un `}<em parentName="p">{`excerpt`}</em>{` (extracto) como para mostrar en una preview, ahora lo
vamos a usar!`}</p>
    <p><strong parentName="p">{`FANTASTICO`}</strong>{`, ya tenemos el backend configurado, la consulta para traer
nuestros posts, qué nos faltaría? Una página donde listarlos, no? Creemos
entonces en `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/pages`}</code>{` un archivo nuevo que se llame `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`blog.js`}</code>{` y completemos como
hicimos para mostrar nuestros repos. La estructura y la idea del archivo sería
muy parecida, así que les dejo cómo lo hice yo en estas pestañas así pueden
intentarlo ustedes 😁`}</p>
    <Tabs mdxType="Tabs">
      <TabList mdxType="TabList">
    <Tab mdxType="Tab">Soluciones</Tab>
    <Tab mdxType="Tab">blog.js</Tab>
      </TabList>
      <TabPanels mdxType="TabPanels">
        <TabPanel mdxType="TabPanel">Para ver la solución hacé click en la pestaña 👆</TabPanel>
        <TabPanel mdxType="TabPanel">
          <div {...{
            "className": "gatsby-highlight",
            "data-language": "javascript"
          }}><pre parentName="div" {...{
              "className": "language-javascript"
            }}><code parentName="pre" {...{
                "className": "language-javascript"
              }}><span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` React `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` Link`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{` useStaticQuery`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{` graphql `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'gatsby'`}</span>{`

`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` Layout `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'../components/layout'`}</span>{`
`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` `}<span parentName="code" {...{
                  "className": "token constant"
                }}>{`SEO`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'../components/seo'`}</span>{`

`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` `}<span parentName="code" {...{
                  "className": "token function-variable function"
                }}>{`BlogPage`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=>`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` posts `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`useStaticQuery`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`graphql`}<span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`
    query {
      allMarkdownRemark {
        totalCount
        edges {
          node {
            id
            frontmatter {
              title
              date(formatString: "DD MMMM, YYYY", locale: "es")
            }
            excerpt
          }
        }
      }
    }
  `}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`return`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`Layout`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token constant"
                }}>{`SEO`}</span>{` title`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span><span parentName="code" {...{
                  "className": "token string"
                }}>{`"Blog"`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`h1`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`Hola`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`h1`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`Este es mi blog `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`Tengo en total `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`posts`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`allMarkdownRemark`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`totalCount`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{` `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`post`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`s`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`posts`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`allMarkdownRemark`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`edges`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span><span parentName="code" {...{
                  "className": "token function"
                }}>{`map`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token parameter"
                }}><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`{`}</span>{` node `}<span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`}`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=>`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`article
          style`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
            border`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'1px solid grey'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
            borderRadius`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'5px'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
            margin`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'24px'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
            padding`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'12px'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
          `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
          `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`h2`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`frontmatter`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`title`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`h2`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
          `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`i`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`frontmatter`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`date`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`i`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
          `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`excerpt`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`article`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`Layout`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`

`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`export`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`default`}</span>{` BlogPage`}</code></pre></div>
        </TabPanel>
      </TabPanels>
    </Tabs>
    <p>{`Una vez que lo tengamos todo listo, guardamos el archivo, esperamos un poquito a
que se haga el `}<em parentName="p">{`rebuild`}</em>{` en nuestro servidor local y vamos a nuestra página
recién creada a ver qué tan lindo quedó todo! http://localhost:8000/blog`}</p>
    <p>{`Listo ya tenemos nuestro blog, chau nos vemos (?) jaja nah, todavía falta ver
cómo hacemos para ver cada post por separado 😜 Además, no vamos a tener un blog
con un solo post, armemos otro! Esta vez usemos la fecha de hoy:`}</p>
    <p>{`Nombre de ejemplo: `}<strong parentName="p">{`segundo-post.md`}</strong></p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "markdown"
    }}><pre parentName="div" {...{
        "className": "language-markdown"
      }}><code parentName="pre" {...{
          "className": "language-markdown"
        }}><span parentName="code" {...{
            "className": "token front-matter-block"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`---`}</span>{`
`}<span parentName="span" {...{
              "className": "token font-matter yaml language-yaml"
            }}>{`title: 'Segundo post'
date: '2019-10-26'`}</span>{`
`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`---`}</span></span>{`

Vengo a hacerle compañía al primer post, que cree que tiene data interesante
pero son palabras sin sentido, pobrecito 😢`}</code></pre></div>
    <p>{`Guardamos y debería sumarse a la lista de nuestros posts automáticamente ✨ La
magia de Gatsby y GraphQL y todo esto 😍 Pero... `}<strong parentName="p">{`El orden de esos posts me
parece que está MAL, yo quiero el más nuevo arriba de todo...`}</strong>{` Ah, sí, tal como
usamos filtros para traer nuestros repos antes, tenemos una forma de `}<strong parentName="p">{`ordenar`}</strong>{`
los posts (se acuerdan del `}<strong parentName="p">{`orderBy`}</strong>{` que usamos?), cambiemos en la query de
nuestro archivo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`blog.js`}</code>{` donde dice solamente `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`allMarkdownRemark`}</code>{` por:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token function"
          }}>{`allMarkdownRemark`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`sort`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` fields`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`[`}</span>{`frontmatter___date`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`]`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` order`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token constant"
          }}>{`DESC`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span></code></pre></div>
    <p><em parentName="p">{`Sí, entre frontmatter y date hay 3 (tres) guiones bajos, no me miren mal`}</em></p>
    <p>{`Y ahora vamos a tener nuestros posts ordenados debidamente, con el más nuevo
arriba de todo 😉 Hicimos que se ordene (`}<em parentName="p">{`sort`}</em>{`) y le indicamos que use el campo
(`}<em parentName="p">{`field`}</em>{`) fecha del frontmatter (`}<em parentName="p">{`frontmatter`}{`_`}{`_`}{`_`}{`date`}</em>{`) en orden descendiente
(`}<em parentName="p">{`order: DESC`}</em>{`).`}</p>
    <p>{`Phew~ cansador esto, no? Pero falta lo mejor! (?) Mostrar los posts uno por uno,
que por lo que sabemos hasta ahora, para hacer páginas creamos un archivo en
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/pages`}</code>{` y ya está, aunque crear `}<strong parentName="p">{`una página por cada post`}</strong>{` no suena muy
conveniente, no? 🤔 Necesitamos una forma de crear las páginas de manera
`}<em parentName="p">{`programática`}</em>{`, y para eso tenemos APIs en nuestro backend 😎 Vamos a usar
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/node-apis/#onCreateNode"
      }}><strong parentName="a">{`onCreateNode`}</strong></a>{` y
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/node-apis/#createPages"
      }}><strong parentName="a">{`createPages`}</strong></a>{`.`}</p>
    <p>{`Empecemos por ver para qué usamos cada uno, así no nos mandamos y tenemos que
volver para atrás:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`createPages`}</strong>{` nos sirve para crear páginas de forma programática, a las
cuales se les genera un `}<em parentName="li">{`contexto`}</em>{` y nosotros por ese contexto podemos pasarle
data de cada post, con qué podríamos traer data de cada post, se les ocurre?
😉 Cuando tengamos eso, nos falta una forma de generar una URL para poder
acceder a cada `}<code parentName="li" {...{
          "className": "language-text"
        }}>{`page`}</code>{` creada, para eso usamos `}<strong parentName="li">{`onCreateNode`}</strong>{`.`}</li>
      <li parentName="ul"><strong parentName="li">{`onCreateNode`}</strong>{` vamos a usarlo para que cuando se cree un
`}<a parentName="li" {...{
          "href": "https://developer.mozilla.org/es/docs/Web/API/Node"
        }}>{`Nodo`}</a>{`, tome ciertos datos
únicos de cada post y nos genere algo que se llama `}<em parentName="li">{`slug`}</em>{`, que va a ser lo que
defina la URL del post.`}</li>
    </ul>
    <h3>{`Creando las URLs`}</h3>
    <p>{`Empecemos por crear la URL para ya tenerla en el contexto cuando creemos cada
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`page`}</code>{`, así que entremos a `}<strong parentName="p">{`gatsby-node.js`}</strong>{` e implementemos las APIs, que se
implementan exportando funciones con el nombre de la API a utilizar:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`exports`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`onCreateNode`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` node `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token string"
          }}>{`'Tipo de nodo: '`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`internal`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`type`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Ahora cortemos y volvamos a correr el servidor local, y miremos la consola, si
prestamos atención se van a crear distintos tipos de nodos: SitePage,
SitePlugin, Directory, File... Pero hay uno que nos interesa más que otros,
dijimos que íbamos a trabajar con nuestros posts que son de tipo `}<strong parentName="p">{`Markdown`}</strong>{`,
si vemos en la consola lo más parecido es `}<strong parentName="p">{`MarkdownRemark`}</strong>{`! Ya tenemos cómo
filtrar nuestros posts entre los nodos creados durante el `}<em parentName="p">{`build`}</em>{`, ahora a
trabajarlos!`}</p>
    <p>{`Para generar el `}<em parentName="p">{`slug`}</em>{` con algo propio de cada post, podemos utilizar el nombre
de archivo, lo cual sería único de cada nodo. Pero para poder acceder a esto,
necesitamos `}<em parentName="p">{`movernos en el grafo de nodos`}</em>{` (suena de una peli de ciencia
ficción 😂) e ir al nodo padre, que es `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`File`}</code>{`, el tipo de nodo que contiene la
data de nuestros archivos en disco, modifiquemos en nuestra función recién
creada:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}>{`exports`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`onCreateNode`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` node`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` getNode `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`internal`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`type `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`===`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`MarkdownRemark`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` fileNode `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`getNode`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`parent`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`\\n`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` fileNode`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`relativePath`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Como estamos modificando los archivos `}<strong parentName="p">{`gatsby-algo`}</strong>{`, por cada modificación que
hagamos, si queremos ver los resultados, debemos frenar y volver a correr
`}<strong parentName="p">{`gatsby develop`}</strong>{` en la consola. Y vamos a ver los nombres de nuestros archivos
flotando por ahí! `}<strong parentName="p">{`YAY`}</strong>{` 🎉🥳`}</p>
    <p>{`Sigamos, como la gente de Gatsby es buena y nos quiere, nos dice que la lógica
para crear estos `}<em parentName="p">{`slugs`}</em>{` es complicada, así que el plugin
`}<strong parentName="p">{`gatsby-source-filesystem`}</strong>{` ya viene con una función para ayudarnos para "crear
el path del archivo", ergo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`createFilePath`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`//Acuerdense que la sintaxis acá es 'node-style'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` createFilePath `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-source-filesystem`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

exports`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`onCreateNode`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` node`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` getNode `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`internal`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`type `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`===`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`MarkdownRemark`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`createFilePath`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` getNode `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Y si reiniciamos el server, vemos los strings! Ya tenemos el dato necesario, lo
que tenemos que hacer ahora es sumarlo a la información del nodo, `}<em parentName="p">{`extender`}</em>{` el
nodo, para que podamos consultar el `}<em parentName="p">{`slug`}</em>{` en el frontend. Cuando implementamos
una API, recibe como parámetros una colección de `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`actions`}</code>{` (acciones) que
podemos usar para manipular state, en nuestro caso nos sirve cierta `}<em parentName="p">{`action`}</em>{`
para extender nuestros nodos:
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/actions/#createNodeField"
      }}><strong parentName="a">{`createNodeField`}</strong></a>{`.`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` createFilePath `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`gatsby-source-filesystem`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

exports`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`onCreateNode`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` node`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` getNode`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` actions `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Conseguimos la action necesaria mediante destructuring`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` createNodeField `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` actions
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`if`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`internal`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`type `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`===`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`MarkdownRemark`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` slug `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`createFilePath`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` getNode `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`// Generamos un nuevo field que extiende nuestro nodo`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`createNodeField`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      name`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`slug`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      value`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` slug`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Reiniciemos el servidor y vayamos a GraphiQL, deberíamos tener un valor nuevo
adentro de cada allMarkdownRemark -> edges -> node que se llame `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`fields`}</code>{`!
Prueben si trae los slugs que recién creamos y sigamos con la creación de las
páginas con `}<strong parentName="p">{`createPages`}</strong>{`! 😁😁`}</p>
    <h3>{`Creando páginas de forma programática`}</h3>
    <p>{`Bueno, venimos bien, agregamos un valor a los nodos de Markdown (nuestros
posts), lo cual nos habilita a poder `}<strong parentName="p">{`consultar ese nuevo valor y mandarlo al
front en cada página mediante createPages`}</strong>{`. Tengan a mano esto que está en
negrita para entender lo que estemos haciendo. El tema es que cada página creada
necesita un `}<em parentName="p">{`template`}</em>{` (plantilla) donde mostrar la data que consigamos de
nuestros posts, así que empecemos por ahí, creemos una carpeta `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`/templates`}</code>{`
adentro de /src, y en /templates creemos un archivo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`blog-post.js`}</code>{` con lo
siguiente:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Layout `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'../components/layout'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Layout`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
      `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`div`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`Acá va un post`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`!`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`div`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`Layout`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Ahora que tenemos una plantilla (que por ahora no hace nada mas que mostrar ese
texto siempre), sigamos con lo nuestro, nosotros sabemos que para usar una API
en nuestro backend, tenemos que exportar la función con el mismo nombre que la
API a usar, así que igual que antes, agregamos `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`exports.createPages`}</code>{` pero con
una salvedad: entre las cosas que nuestras APIs reciben por parámetro (de las
cuales antes usamos node, getNode, actions), vamos a usar `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`graphql`}</code>{`, la cual es
una función que retorna una
`}<a parentName="p" {...{
        "href": "https://developer.mozilla.org/es/docs/Web/JavaScript/Referencia/Objetos_globales/Promise"
      }}>{`Promise`}</a>{`,`}<br parentName="p"></br>{`
`}{`las cuales se pueden resolver de dos formas, con `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.then()`}</code>{` y `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`.catch()`}</code>{` o con
`}<code parentName="p" {...{
        "className": "language-text"
      }}>{`async/await`}</code>{`. Vamos con la segunda opción ya que de otra forma tendríamos
algunos problemas de asincronismo con las funciones que nos provee Gatsby, así
que agreguemos esto:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`//En gatsby-node.js, abajo de nuestra función exports.createNode:`}</span>{`
exports`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`createPages`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`async`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` graphql`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` actions `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`await`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`graphql`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
    query {
      allMarkdownRemark {
        edges {
          node {
            fields {
              slug
            }
          }
        }
      }
    }
  `}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  console`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`log`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token constant"
          }}>{`JSON`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`stringify`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`result`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`null`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{` `}<span parentName="code" {...{
            "className": "token number"
          }}>{`2`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Y vamos a ver en la consola el resultado de nuestra query, son los `}<em parentName="p">{`slugs`}</em>{` que
generamos antes! 😄`}</p>
    <Image imgName="cmdquery.png" alt="Slug in Command Line" style={{
      width: '25vw',
      margin: '0 auto'
    }} mdxType="Image" />
    <p>{`Ya tenemos el `}<em parentName="p">{`template`}</em>{` y los `}<em parentName="p">{`slugs`}</em>{`, ahora unamos todo con una `}<em parentName="p">{`action`}</em>{` de
`}<strong parentName="p">{`createPages`}</strong>{` que nos permite configurar y pasar data por medio de un
`}<em parentName="p">{`context`}</em>{` a cada página creada:
`}<a parentName="p" {...{
        "href": "https://www.gatsbyjs.org/docs/actions/#createPage"
      }}><strong parentName="a">{`createPage`}</strong></a>{` 😏`}</p>
    <p>{`Vamos a mandarle en `}<strong parentName="p">{`path`}</strong>{`, la dirección que va a tener cada post, o sea, el
`}<em parentName="p">{`slug`}</em>{`; también vamos a mandarle en `}<strong parentName="p">{`component`}</strong>{` una referencia al componente
`}<em parentName="p">{`template`}</em>{` que creamos antes, y por `}<strong parentName="p">{`context`}</strong>{` vamos a mandar el `}<em parentName="p">{`slug`}</em>{`, que la
data enviada por `}<strong parentName="p">{`context`}</strong>{` va a estar disponible en `}<strong parentName="p">{`queries de página como
variables de GraphQL`}</strong>{`. Ah, y para referenciar al componente ahora que estamos
desde el backend, necesitamos importar `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`path`}</code>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token comment"
          }}>{`//En gatsby-node.js`}</span>{`
`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//Arriba de todo agregamos esta línea`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` path `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`require`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`path`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`

`}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//Luego nuestro createPages debería quedar así`}</span>{`
exports`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function-variable function"
          }}>{`createPages`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`async`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` graphql`}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`,`}</span>{` actions `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//Conseguimos nuestra action`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` createPage `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` actions
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` result `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`await`}</span>{` `}<span parentName="code" {...{
            "className": "token function"
          }}>{`graphql`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
    query {
      allMarkdownRemark {
        edges {
          node {
            fields {
              slug
            }
          }
        }
      }
    }
  `}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  result`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`data`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`allMarkdownRemark`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`edges`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`forEach`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` node `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
    `}<span parentName="code" {...{
            "className": "token comment"
          }}>{`//Configuramos cada página con la data de cada nodo`}</span>{`
    `}<span parentName="code" {...{
            "className": "token function"
          }}>{`createPage`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
      path`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`fields`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`slug`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      component`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` path`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span><span parentName="code" {...{
            "className": "token function"
          }}>{`resolve`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`./src/templates/blog-post.js`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      context`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
        slug`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` node`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`fields`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`slug`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
      `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`,`}</span>{`
    `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span></code></pre></div>
    <p>{`Nuestro `}<strong parentName="p">{`gatsby-node.js`}</strong>{` debería quedar algo así:`}</p>
    <Tabs mdxType="Tabs">
      <TabList mdxType="TabList">
    <Tab mdxType="Tab">Soluciones</Tab>
    <Tab mdxType="Tab">gatsby-node.js</Tab>
      </TabList>
      <TabPanels mdxType="TabPanels">
        <TabPanel mdxType="TabPanel">Para ver la solución hacé click en la pestaña 👆</TabPanel>
        <TabPanel mdxType="TabPanel">
          <div {...{
            "className": "gatsby-highlight",
            "data-language": "javascript"
          }}><pre parentName="div" {...{
              "className": "language-javascript"
            }}><code parentName="pre" {...{
                "className": "language-javascript"
              }}><span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` path `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`require`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`path`}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` createFilePath `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`require`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`gatsby-source-filesystem`}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`

exports`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span><span parentName="code" {...{
                  "className": "token function-variable function"
                }}>{`onCreateNode`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token parameter"
                }}><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`{`}</span>{` node`}<span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`,`}</span>{` getNode`}<span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`,`}</span>{` actions `}<span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`}`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=>`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token comment"
                }}>{`// Conseguimos la action necesaria mediante destructuring`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` createNodeField `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` actions
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`if`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`internal`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`type `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`===`}</span>{` `}<span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`MarkdownRemark`}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` slug `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`createFilePath`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{` getNode `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token comment"
                }}>{`// Generamos un nuevo field que extiende nuestro nodo`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`createNodeField`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
      node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      name`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`slug`}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      value`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` slug`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`

exports`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span><span parentName="code" {...{
                  "className": "token function-variable function"
                }}>{`createPages`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`async`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token parameter"
                }}><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`{`}</span>{` graphql`}<span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`,`}</span>{` actions `}<span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`}`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=>`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token comment"
                }}>{`//Conseguimos nuestra action`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` createPage `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` actions
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` result `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`await`}</span>{` `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`graphql`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`
    query {
      allMarkdownRemark {
        edges {
          node {
            fields {
              slug
            }
          }
        }
      }
    }
  `}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
  result`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`data`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`allMarkdownRemark`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`edges`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span><span parentName="code" {...{
                  "className": "token function"
                }}>{`forEach`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token parameter"
                }}><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`{`}</span>{` node `}<span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`}`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=>`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token comment"
                }}>{`//Configuramos cada página con la data de cada nodo`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`createPage`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
      path`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`fields`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`slug`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      component`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` path`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span><span parentName="code" {...{
                  "className": "token function"
                }}>{`resolve`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`./src/templates/blog-post.js`}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      context`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
        slug`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`fields`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`slug`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span></code></pre></div>
        </TabPanel>
      </TabPanels>
    </Tabs>
    <p>{`Si reiniciamos el servidor local se van a crear nuestras páginas, `}<strong parentName="p">{`VAMO!`}</strong>{`
Pero, cómo accedemos? A mano? 🤔 Una forma de ver las páginas creadas es forzar
un 404, así que vayamos a una dirección random http://localhost:8000/hn934b3 y
vamos a verlas en el listado, háganle click y verán que carga el template que
hicimos, que mucho como plantilla no estaría funcionando 🤣 Arreglemos eso!`}</p>
    <p>{`Lo que podemos hacer ahora es consultar la data de cada post filtrando por su
`}<strong parentName="p">{`slug`}</strong>{`! Eso lo hacemos en nuestro template con una query `}<strong parentName="p">{`de página`}</strong>{`:`}</p>
    <div {...{
      "className": "gatsby-highlight",
      "data-language": "javascript"
    }}><pre parentName="div" {...{
        "className": "language-javascript"
      }}><code parentName="pre" {...{
          "className": "language-javascript"
        }}><span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` React `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` graphql `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'gatsby'`}</span>{`
`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`import`}</span>{` Layout `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`from`}</span>{` `}<span parentName="code" {...{
            "className": "token string"
          }}>{`'../components/layout'`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`default`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span><span parentName="code" {...{
            "className": "token parameter"
          }}><span parentName="span" {...{
              "className": "token punctuation"
            }}>{`{`}</span>{` data `}<span parentName="span" {...{
              "className": "token punctuation"
            }}>{`}`}</span></span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=>`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` post `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` data`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`markdownRemark
  `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`return`}</span>{` `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`(`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`Layout`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
      `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`div`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
        `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`h1`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{`post`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`frontmatter`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`title`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`h1`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
        `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span>{`div dangerouslySetInnerHTML`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`{`}</span>{` __html`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`:`}</span>{` post`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`.`}</span>{`html `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span><span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{` `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
      `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`div`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
    `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`<`}</span><span parentName="code" {...{
            "className": "token operator"
          }}>{`/`}</span>{`Layout`}<span parentName="code" {...{
            "className": "token operator"
          }}>{`>`}</span>{`
  `}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`)`}</span>{`
`}<span parentName="code" {...{
            "className": "token punctuation"
          }}>{`}`}</span>{`

`}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`export`}</span>{` `}<span parentName="code" {...{
            "className": "token keyword"
          }}>{`const`}</span>{` query `}<span parentName="code" {...{
            "className": "token operator"
          }}>{`=`}</span>{` graphql`}<span parentName="code" {...{
            "className": "token template-string"
          }}><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span><span parentName="span" {...{
              "className": "token string"
            }}>{`
  query($slug: String!) {
    markdownRemark(fields: { slug: { eq: $slug } }) {
      html
      frontmatter {
        title
      }
    }
  }
`}</span><span parentName="span" {...{
              "className": "token template-punctuation string"
            }}>{`\``}</span></span></code></pre></div>
    <p>{`Eh? `}<em parentName="p">{`Query de página`}</em>{`??? Sí, en Gatsby hay dos formas de consultar data:`}</p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Normal (o Page) Queries`}</strong>{` (Query de página)`}</li>
      <li parentName="ul"><strong parentName="li">{`Static Queries`}</strong>{` (Query estática)`}</li>
    </ul>
    <p>{`Una de las principales diferencias entre las dos es que la `}<em parentName="p">{`Query de página`}</em>{`
puede usarse solamente en los componentes de `}<strong parentName="p">{`página`}</strong>{`, y era la única forma de
consultar data en Gatsby v1. Luego desarrollaron la `}<em parentName="p">{`Query estática`}</em>{`, que
apareció en Gatsby v2 y fue fundamental para eliminar lo que se llama `}<em parentName="p">{`prop
drilling`}</em>{`, que es pasar data (o state) mediante props de padre a hijos en
múltiples niveles, suponiendo que a veces esa data se pasaba unas 3 ó 4 (o más)
veces, lo cual volvía el código inmantenible. Las `}<em parentName="p">{`Static Queries`}</em>{` pueden
utilizarse tanto en componentes `}<strong parentName="p">{`comunes`}</strong>{` como en componentes de `}<strong parentName="p">{`página`}</strong>{`.`}</p>
    <p>{`Y la última gran diferencia es que la `}<em parentName="p">{`Query de página`}</em>{` `}<strong parentName="p">{`acepta variables`}</strong>{`,
las cuales se reciben mediante el `}<em parentName="p">{`contexto de página`}</em>{` o `}<strong parentName="p">{`pageContext`}</strong>{`, el cual
creamos recién en gatsby-node.js en la función `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`createPage`}</code>{`. La estática, tal
como su nombre indica, `}<strong parentName="p">{`no`}</strong>{` acepta variables porque `}<strong parentName="p">{`no`}</strong>{` tiene acceso al
contexto de página.`}</p>
    <p>{`En la query de página de arriba vemos que se indica que esa query recibe una
variable (indicada con el signo `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`$`}</code>{`) de nombre `}<strong parentName="p">{`slug`}</strong>{` y de tipo `}<strong parentName="p">{`String`}</strong>{`, el
signo de exclamación indica que esa variable es `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`requerida`}</code>{`.`}</p>
    <p>{`Bueno, sigamos con el blog! 😛`}</p>
    <p>{`Ya casi no nos queda nada! Nos falta vincular cada post del listado con su
página creada! Vayamos a `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`blog.js`}</code>{` en `}<strong parentName="p">{`pages`}</strong>{` y agreguemos lo que nos falta,
se los dejo a ustedes y la solución acá abajo, no pispeen sin intentarlo eh!!!
😝`}</p>
    <Tabs mdxType="Tabs">
      <TabList mdxType="TabList">
    <Tab mdxType="Tab">Soluciones</Tab>
    <Tab mdxType="Tab">pages/blog.js</Tab>
      </TabList>
      <TabPanels mdxType="TabPanels">
        <TabPanel mdxType="TabPanel">Para ver la solución hacé click en la pestaña 👆</TabPanel>
        <TabPanel mdxType="TabPanel">
          <div {...{
            "className": "gatsby-highlight",
            "data-language": "javascript"
          }}><pre parentName="div" {...{
              "className": "language-javascript"
            }}><code parentName="pre" {...{
                "className": "language-javascript"
              }}><span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` React `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'react'`}</span>{`
`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` Link`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{` useStaticQuery`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{` graphql `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'gatsby'`}</span>{`

`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` Layout `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'../components/layout'`}</span>{`
`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`import`}</span>{` `}<span parentName="code" {...{
                  "className": "token constant"
                }}>{`SEO`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`from`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'../components/seo'`}</span>{`

`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` `}<span parentName="code" {...{
                  "className": "token function-variable function"
                }}>{`BlogPage`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=>`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`const`}</span>{` posts `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span>{` `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`useStaticQuery`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`graphql`}<span parentName="code" {...{
                  "className": "token template-string"
                }}><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span><span parentName="span" {...{
                    "className": "token string"
                  }}>{`
    query {
      allMarkdownRemark(sort: { fields: [frontmatter___date], order: DESC }) {
        totalCount
        edges {
          node {
            id
            frontmatter {
              title
              date(formatString: "DD MMMM, YYYY", locale: "es")
            }
            fields {
              slug
            }
            excerpt
          }
        }
      }
    }
  `}</span><span parentName="span" {...{
                    "className": "token template-punctuation string"
                  }}>{`\``}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`return`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`Layout`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token constant"
                }}>{`SEO`}</span>{` title`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span><span parentName="code" {...{
                  "className": "token string"
                }}>{`"Blog"`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`h1`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`Hola`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`h1`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`Este es mi blog `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`Tengo en total `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`posts`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`allMarkdownRemark`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`totalCount`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{` `}<span parentName="code" {...{
                  "className": "token function"
                }}>{`post`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`s`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`posts`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`allMarkdownRemark`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`edges`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span><span parentName="code" {...{
                  "className": "token function"
                }}>{`map`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span><span parentName="code" {...{
                  "className": "token parameter"
                }}><span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`{`}</span>{` node `}<span parentName="span" {...{
                    "className": "token punctuation"
                  }}>{`}`}</span></span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{` `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=>`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`(`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`Link
          to`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`fields`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`slug`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
          style`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{` textDecoration`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'none'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{` color`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'#2f2f2f'`}</span>{` `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
          `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`article
            style`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`=`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`
              border`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'1px solid grey'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
              borderRadius`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'5px'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
              margin`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'24px'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
              padding`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`:`}</span>{` `}<span parentName="code" {...{
                  "className": "token string"
                }}>{`'12px'`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`,`}</span>{`
            `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
          `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
            `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`h2`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`frontmatter`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`title`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`h2`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
            `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`i`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`frontmatter`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`date`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`i`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
            `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`{`}</span>{`node`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`.`}</span>{`excerpt`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`p`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
          `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`article`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
        `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`Link`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
      `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span><span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`
    `}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`<`}</span><span parentName="code" {...{
                  "className": "token operator"
                }}>{`/`}</span>{`Layout`}<span parentName="code" {...{
                  "className": "token operator"
                }}>{`>`}</span>{`
  `}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`)`}</span>{`
`}<span parentName="code" {...{
                  "className": "token punctuation"
                }}>{`}`}</span>{`

`}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`export`}</span>{` `}<span parentName="code" {...{
                  "className": "token keyword"
                }}>{`default`}</span>{` BlogPage`}</code></pre></div>
        </TabPanel>
      </TabPanels>
    </Tabs>
    <p>{`Terminado nuestro blog! Ya nos queda ponerlo lindo pero la funcionalidad está!
😀😀😀😀 Espero que hayan disfrutado este workshop, cualquier duda o sugerencia
escríbanme y con gusto ayudo en lo que pueda, pueden encontrarme en Twitter como
`}<a parentName="p" {...{
        "href": "https://twitter.com/AgustinDMulet"
      }}>{`@AgustinDMulet`}</a>{`, nos vemos gente!!!`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      